import React, { useState, useEffect } from "react";

export default function JAVAtest(props) {
  const correctAnswers = [0, 3, 2, 1, 0, 1, 3, 0, 0, 2, 2, 0, 3, 1, 0, 0, 0, 1, 2, 1, 0, 2, 1, 1, 0];
  const que = {
    q1: {
      string: "1. Which of the following is a feature of Java?",
      options: ["Dynamic", "Use of pointers", "Platform dependent", "Supports operator overloading"],
      ans: 0
    },
    q2: {
      string: "2. Which of the following is not a primitive data type in Java?",
      options: ["int", "float", "char", "array"],
      ans: 3
    },
    q3: {
      string: "3. Which of the following is a valid declaration of a boolean?",
      options: ["boolean b1 = 0;", "boolean b2 = 'false';", "boolean b3 = false;", "boolean b4 = True;"],
      ans: 2
    },
    q4: {
      string: "4. Which of the following is a reserved keyword in Java?",
      options: ["string", "class", "method", "object"],
      ans: 1
    },
    q5: {
      string: "5. What is the correct way to declare a variable to store an integer value in Java?",
      options: ["int x;", "x = int;", "integer x;", "Integer x;"],
      ans: 0
    },
    q6: {
      string: "6. What is the output of 'System.out.println(1 + '1');' in Java?",
      options: ["2", "11", "Error", "None of the above"],
      ans: 1
    },
    q7: {
      string: "7. Which of the following is not a Java keyword?",
      options: ["static", "void", "private", "then"],
      ans: 3
    },
    q8: {
      string: "8. What is the correct signature for the main method in Java?",
      options: ["public static void main(String[] args)", "public void main(String[] args)", "public static int main(String[] args)", "public static void main()"],
      ans: 0
    },
    q9: {
      string: "9. Which operator is used to compare two values for equality in Java?",
      options: ["==", "=", "===", "!"],
      ans: 0
    },
    q10: {
      string: "10. What is the output of 'System.out.println(9 / 2);' in Java?",
      options: ["4.5", "4", "4.0", "Error"],
      ans: 2
    },
    q11: {
      string: "11. Which of the following is the correct way to declare an array in Java?",
      options: ["int arr[];", "array arr[];", "int[] arr;", "Array arr[];"],
      ans: 2
    },
    q12: {
      string: "12. Which of the following is the correct way to create an object in Java?",
      options: ["Object obj = new Object();", "object obj = Object();", "Object obj = Object;", "object obj = new object();"],
      ans: 0
    },
    q13: {
      string: "13. What is the default value of the local variables in Java?",
      options: ["0", "null", "undefined", "Depends on the data type"],
      ans: 3
    },
    q14: {
      string: "14. What is the output of 'System.out.println('a' + 1);' in Java?",
      options: ["a1", "2", "b", "Error"],
      ans: 1
    },
    q15: {
      string: "15. Which of the following statements is used to terminate a loop in Java?",
      options: ["break;", "terminate;", "exit;", "stop;"],
      ans: 0
    },
    q16: {
      string: "16. Which of the following is a correct way to comment multiple lines in Java?",
      options: ["/* This is a comment */", "// This is a comment", "# This is a comment", "<!-- This is a comment -->"],
      ans: 0
    },
    q17: {
      string: "17. Which of the following is the correct syntax to define a method in Java?",
      options: ["method myMethod() {}", "void myMethod() {}", "define myMethod() {}", "function myMethod() {}"],
      ans: 1
    },
    q18: {
      string: "18. What does the 'final' keyword signify in Java?",
      options: ["The method cannot be overridden", "The method cannot be called", "The method is static", "The method is private"],
      ans: 0
    },
    q19: {
      string: "19. What is the output of 'System.out.println(Math.max(10, 20));' in Java?",
      options: ["10", "20", "30", "Error"],
      ans: 2
    },
    q20: {
      string: "20. Which of the following is a correct way to define a constant in Java?",
      options: ["const PI = 3.14;", "final double PI = 3.14;", "double PI = 3.14;", "var PI = 3.14;"],
      ans: 1
    },
    q21: {
      string: "21. What is the correct way to create a method in Java that does not return any value?",
      options: ["void myMethod()", "int myMethod()", "myMethod()", "returnType myMethod()"],
      ans: 0
    },
    q22: {
      string: "22. Which of the following is used to read user input in Java?",
      options: ["readInput()", "input()", "Scanner", "console"],
      ans: 2
    },
    q23: {
      string: "23. What is the output of 'System.out.println('10' + 20);' in Java?",
      options: ["30", "1020", "Error", "None of the above"],
      ans: 1
    },
    q24: {
      string: "24. What does the 'super' keyword refer to in Java?",
      options: ["The current class instance", "The parent class instance", "The static context", "The child class instance"],
      ans: 1
    },
    q25: {
      string: "25. Which of the following is the correct way to declare and initialize a string in Java?",
      options: ["String s = 'Hello';", "String s; s = 'Hello';", "String s; s = new String('Hello');", "String s = new String('Hello');"],
      ans: 0
    }
  };

  const [ques, setques] = useState(que.q1.string);
  const [opts, setoptions] = useState(que.q1.options);
  const [userAns, setUserAns] = useState(null);
  const [userAnswers, setUserAnswers] = useState(Array(25).fill(null));
  const [score, setScore] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [timeLeft, setTimeLeft] = useState(900);
  let timer;
  useEffect(() => {
    timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          submitTest();
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const renderNext = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion + 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const renderPrevious = () => {
    if (userAns !== null) {
      const newAnswers = [...userAnswers];
      newAnswers[currentQuestion - 1] = userAns;
      setUserAnswers(newAnswers);
    }
    setUserAns(null);
    let newCount = currentQuestion - 1;
    let newQue = que[`q${newCount}`]?.string;
    let newOpt = que[`q${newCount}`]?.options;
    if (newQue !== undefined) {
      setques(newQue);
      setoptions(newOpt);
      setCurrentQuestion(newCount);
    }
  };

  const handleAnswer = (answerIndex) => {
    setUserAns(answerIndex);
  };

  const submitTest = () => {
    setTimeLeft(0);

    setUserAnswers((prevUserAnswers) => {
      const newAnswers = [...prevUserAnswers];
      if (userAns !== null) {
        newAnswers[currentQuestion - 1] = userAns;
      }

      let newScore = 0;
      for (let i = 0; i < 25; i++) {
        if (correctAnswers[i] === newAnswers[i]) {
          newScore++;
        }
      }
      setScore(newScore);

      return newAnswers;
    });
  };

  return (
    <div className={props.mode}>
      <div className="heading">
        <h1>JAVA <span>Skill</span> Test</h1>
      </div>
      <div className="codingInformation">
        <div className="time">
          <h1>Time Left: {formatTime(timeLeft)}</h1> 
        </div>
        <div className="score">
          <span>Your Score: {score}</span>
        </div>
        <div className="tracker">
          <span>Track Your Question</span>
        </div>
      </div>
      <div className="mobileTracker">
        <span>Track Your Question</span>
      </div>
      <div className="mainCodingContainer">
        <div className="questionContainer">
          <p>{ques}</p>
          <div className="options">
            {opts.map((option, index) => (
              <div key={index} className={`opt${index + 1}`}>
                <input
                  type="radio"
                  name={`que${currentQuestion}`}
                  onChange={() => handleAnswer(index)}
                  checked={userAns === index}
                />
                <label>{option}</label>
              </div>
            ))}
          </div>
          <div className="btns">
            <button className="btn" onClick={renderPrevious}>Previous</button>
            <button className="btn" onClick={renderNext}>Next</button>
            <button className="btn" id="submitTest" onClick={submitTest}>Submit Test</button>
          </div>
          <div className="mobsub">
          <button className="btn" id="mobileSubmitTest" onClick={submitTest}>Submit Test</button>
          </div>
        </div>
        <div className="questionTrackerContainer">
          <div className="qtboxInformation">
            <div></div>
            <strong>Current</strong>
            <div></div>
            <strong id="solved">Solved</strong>
            <div></div>
            <strong id="unsolved">Unsolved</strong>
          </div>
          <div className="questionTracker">
            {[...Array(25)].map((_, i) => (
              <div
                key={i}
                className={`question ${currentQuestion === i + 1 ? 'current-question' : ''} ${userAnswers[i] !== null ? 'solved' : 'unsolved'}`}
              >
                {i + 1}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
